import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-3 pr-0 md:px-0" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "my-6" }
const _hoisted_6 = { class: "hidden md:block bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "font-bold text-black" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-sm text-black" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-sm text-black" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "font-medium text-black" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "text-black"
}
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = ["title"]
const _hoisted_19 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "font-bold text-green-600" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-red-600 font-semibold" }
const _hoisted_25 = ["href"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "md:hidden space-y-3 mr-0" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "flex justify-between items-start mb-2 pb-2 border-b border-gray-200" }
const _hoisted_31 = { class: "font-bold text-base text-black" }
const _hoisted_32 = { class: "text-xs text-black mt-0.5" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "grid grid-cols-2 gap-2 text-xs mb-2" }
const _hoisted_35 = { class: "font-medium text-black mt-0.5" }
const _hoisted_36 = {
  key: 0,
  class: "flex gap-1 mt-1"
}
const _hoisted_37 = {
  key: 0,
  class: "bg-blue-600 px-1.5 py-0.5 rounded text-white text-[10px]"
}
const _hoisted_38 = {
  key: 1,
  class: "inline-flex items-center gap-1 bg-gradient-to-r from-gray-900 to-black px-2 py-0.5 rounded-full text-white text-[10px] font-semibold shadow ring-1 ring-white/10"
}
const _hoisted_39 = { class: "font-medium text-black mt-0.5" }
const _hoisted_40 = {
  key: 0,
  class: "text-[10px] text-black mt-0.5"
}
const _hoisted_41 = { class: "font-bold text-green-600 mt-0.5" }
const _hoisted_42 = { class: "text-red-600 font-semibold mt-0.5" }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "my-6" }

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  PageHeader,
  OrderFilters,
  ReusableTable,
  UnifiedPagination,
} from "@/components";
import type { Order, OrderFilters as OrderFiltersType } from "@/types/order";
import { formatDateFR } from "@/utils/date";
import { truncateText } from "@/utils/string";
import {
  ordersList,
  updateOrderStatus,
  addComment,
  getOrderById,
} from "@/api/orders";
import CommentModal from "@/components/common/CommentModal.vue";
import CancelOrderModal from "@/components/modals/CancelOrderModal.vue";
import LabelGenerationModal from "@/components/modals/LabelGenerationModal.vue";
import type { OrderDetailResponse } from "@/types";
import { useNotification } from "@/composables/useNotification";
import { useAuthStore } from "@/stores/auth";
import { useOrdersStore } from "@/stores/ordersStore";
import { invalidateDashboardCache } from "@/utils/dashboardCache";


export default /*@__PURE__*/_defineComponent({
  __name: 'MyOrdersView',
  setup(__props) {

const authStore = useAuthStore();
const ordersStore = useOrdersStore();

const router = useRouter();
const route = useRoute();
const { success, error: showError } = useNotification();

// État global de la page
const sellerOrders = ref<Order[]>([]);
const isLoading = ref(false);
// Filtres actifs (gestion d'état avec ref uniquement, pas d'URL)
const activeFilters = ref<OrderFiltersType | null>(null);

// États pour la modal d'annulation
const showCancelModal = ref(false);
const cancelOrderId = ref<number | null>(null);
const isCanceling = ref(false);

// États pour la modal de génération d'étiquettes
const showLabelGenerationModal = ref(false);
const selectedOrderForValidation = ref<number | null>(null);
const orderDetailForValidation = ref<OrderDetailResponse | null>(null);
const pendingGroupageStatus = ref<number | null>(null);

// États pour le modal de commentaire
const showCommentModal = ref(false);
const selectedOrderId = ref<number | null>(null);

const openCancelModal = (orderId: number) => {
  cancelOrderId.value = orderId;
  showCancelModal.value = true;
};

const confirmCancelOrder = async (
  reasonCode: string,
  reasonDetail?: string,
) => {
  if (!cancelOrderId.value || isCanceling.value) return;

  isCanceling.value = true;
  try {
    const isCancelled = await cancelOrder(
      cancelOrderId.value,
      reasonCode,
      reasonDetail,
    );
    if (isCancelled) {
      showCancelModal.value = false;
      cancelOrderId.value = null;
    }
  } finally {
    isCanceling.value = false;
  }
};

// Gérer la validation d'une commande
const handleValidateOrder = (
  row: Order & { orderId?: number; orderGroupId?: number },
) => {
  const orderIdRaw = (row as any).orderId || row.id;
  if (!orderIdRaw) {
    showError("ID de commande invalide");
    return;
  }

  const orderId = Number(orderIdRaw);
  if (isNaN(orderId)) {
    showError("ID de commande invalide");
    return;
  }

  // Naviguer vers la page de détail et scroller vers le statut
  router.push({
    name: "orderdetails-detail",
    params: { id: orderId.toString() },
    query: { ...route.query, scrollTo: "statut" },
  });
};

// Gérer la génération réussie des étiquettes
const handleLabelsGenerated = async () => {
  if (!selectedOrderForValidation.value || pendingGroupageStatus.value === null)
    return;

  try {
    // Confirmer la commande avec le statut approprié
    await changeStatus(
      selectedOrderForValidation.value,
      pendingGroupageStatus.value,
    );

    // Invalider le cache du dashboard pour mettre à jour les statistiques
    const currentUser = authStore.user;
    if (currentUser?.id) {
      invalidateDashboardCache(currentUser.id);
    }

    // Recharger les données (les filtres sont déjà dans activeFilters)
    await loadOrders();

    // Message de succès
    success("Commande confirmée et étiquettes générées avec succès");

    // Fermer la modal et réinitialiser
    showLabelGenerationModal.value = false;
    selectedOrderForValidation.value = null;
    orderDetailForValidation.value = null;
    pendingGroupageStatus.value = null;
  } catch (error) {
    showError("Erreur lors de la confirmation de la commande");
  }
};

const refreshValidationOrder = async () => {
  if (!selectedOrderForValidation.value) return;
  orderDetailForValidation.value = await getOrderById(
    selectedOrderForValidation.value,
  );
};

// Méthodes pour le modal de commentaire
const handleComment = (orderId: number) => {
  selectedOrderId.value = orderId;
  showCommentModal.value = true;
};

const closeCommentModal = () => {
  showCommentModal.value = false;
  selectedOrderId.value = null;
};

const submitComment = async (commentData: { comment: string }) => {
  if (selectedOrderId.value && commentData.comment.trim()) {
    try {
      await addComment(selectedOrderId.value, commentData.comment);
      // Recharger les données (les filtres sont déjà dans activeFilters)
      await loadOrders();
      closeCommentModal();
    } catch (error) {
      // Gérer l'erreur (afficher un message à l'utilisateur)
    }
  }
};
// ----------------------------------------

// État de la pagination
const currentPage = ref(1);
const itemsPerPage = ref(25);
const totalItems = ref(0);

const parsePositiveInt = (
  value: unknown,
  fallback: number,
  allowedValues?: number[],
): number => {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) return fallback;
  if (allowedValues && !allowedValues.includes(parsed)) return fallback;
  return parsed;
};

const syncPaginationFromQuery = () => {
  currentPage.value = parsePositiveInt(route.query.page, 1);
  itemsPerPage.value = parsePositiveInt(route.query.limit, 25, [
    10, 25, 50, 100,
  ]);
};

const syncQueryFromPagination = async () => {
  const nextQuery = {
    ...route.query,
    page: String(currentPage.value),
    limit: String(itemsPerPage.value),
  };
  await router.replace({ query: nextQuery });
};

const orders = computed(() => {
  return sellerOrders.value.map((order: any) => {
    order.orderId = Number(order.id_commande); // Convertir en nombre
    // Pour les groupages (UPS groupage, etc.) : si id_commande_groupe manquant, utiliser id_commande
    const groupageValue = order.commandeGroupe?.groupage;
    const isGroupage = groupageValue == 1 || groupageValue == "1";
    const rawGroupId = Number(order.id_commande_groupe);
    order.orderGroupId =
      rawGroupId && !isNaN(rawGroupId) ? rawGroupId : order.orderId;
    order.packageCount = order.nb_colis;
    // Construire le texte du transporteur
    const carrierLibelle = order.livraison?.libelle || "Non défini";
    order.carrier = carrierLibelle;
    order.isGroupage = !!isGroupage;
    order.buyer = order.acheteur?.nomSociete || "Non défini";
    order.isPremiereCommande = !!order.isPremiereCommande;
    // Total HT = montantCA si disponible et non nul/zéro, sinon montantApresRemise
    order.totalExclTax =
      order.montantCA != null && order.montantCA !== 0
        ? order.montantCA
        : order.montantApresRemise ?? order.montantTotal;
    // Rupture HT = montant des produits en rupture après remise (comme l'ancien système)
    order.shortageExclTax = order.montantRuptureHT ?? 0;
    order.status = order.commandeStatut?.id_statut || order.statut;
    order.orderDate = formatDateFR(order.dateCommande);
    order.groupageDate =
      isGroupage && order.commandeGroupe?.date_expedition
        ? formatDateFR(order.commandeGroupe.date_expedition)
        : null;
    order.shipmentDate = formatDateFR(order.dateExpedition);
    return order;
  });
});

// En-têtes du tableau
const tableHeaders = ref([
  { key: "orderId", title: "N° commande", sortable: false, align: "center" },
  {
    key: "orderDate",
    title: "Date commande",
    sortable: false,
    align: "center",
  },
  {
    key: "groupageDate",
    title: "Date groupage",
    sortable: false,
    align: "center",
  },
  { key: "buyer", title: "Client", sortable: false, align: "center" },
  { key: "totalExclTax", title: "Total HT", sortable: false, align: "center" },
  {
    key: "shortageExclTax",
    title: "Rupture HT",
    sortable: false,
    align: "center",
  },
  { key: "carrier", title: "Transporteur", sortable: false, align: "center" },
  { key: "status", title: "Statut", sortable: false, align: "center" },
  { key: "action", title: "Actions", sortable: false, align: "center" },
]);

const statusLegend: Record<
  string,
  { color: string; border: string; label: string; text?: string }
> = {
  "0": {
    color: "bg-gray-300",
    border: "!border-l-gray-300",
    label: "EN PANIER",
  },
  "1": {
    color: "bg-yellow-300",
    border: "!border-l-yellow-300",
    label: "NOUVEAU",
  },
  "2": {
    color: "bg-green-300",
    border: "!border-l-green-300",
    label: "EXPÉDIÉE",
  },
  "3": { color: "bg-red-300", border: "!border-l-red-300", label: "ANNULÉE" },
  "4": {
    color: "bg-blue-300",
    border: "!border-l-blue-300",
    label: "CONFIRMÉE",
  },
  "6": {
    color: "bg-pink-300",
    border: "!border-l-pink-300",
    label: "PRÉPARATION DE GROUPAGE",
  },
  "7": { color: "bg-cyan-300", border: "!border-l-cyan-300", label: "PICKUP" },
  "8": {
    color: "bg-lime-300",
    border: "!border-l-lime-300",
    label: "PICKUP EFFECTUÉ",
  },
  "9": {
    color: "bg-amber-300",
    border: "!border-l-amber-300",
    label: "NOUVEAU",
  },
  "10": {
    color: "bg-gray-400",
    border: "!border-l-gray-400",
    label: "SAUVEGARDÉE",
  },
  "11": {
    color: "bg-indigo-300",
    border: "!border-l-indigo-300",
    label: "VALIDATION PAIEMENT",
  },
  "12": {
    color: "bg-orange-300",
    border: "!border-l-orange-300",
    label: "BLOQUÉE",
  },
  "14": {
    color: "bg-[#DDA0DD]",
    border: "!border-l-[#DDA0DD]",
    text: "text-purple-900",
    label: "REÇU AU DÉPÔT",
  },
};

// Méthodes de gestion des données
const currentStatus = (statusId: string) => {
  const entry = statusLegend[statusId];
  if (!entry) {
    return {
      style:
        "inline-flex items-center px-3 py-1.5 rounded-xl text-xs font-semibold bg-gray-300 text-black",
      label: "—",
    };
  }
  const bg = entry.color;
  const txt =
    entry.text || bg.replace(/^bg-/, "text-").replace(/-(100|200|300|400)/, "-800");
  return {
    style: `inline-flex items-center px-3 py-1.5 rounded-xl text-xs font-semibold ${bg} ${txt}`,
    label: entry.label,
  };
};

const loadOrders = async () => {
  isLoading.value = true;
  try {
    const page = currentPage.value;
    const limit = itemsPerPage.value;
    // Utiliser les filtres actifs stockés dans activeFilters
    const orders: {
      data: Order[];
      total: number;
      page: number;
      limit: number;
    } = await ordersList(page, limit, activeFilters.value || undefined);

    totalItems.value = orders.total;
    sellerOrders.value = orders.data;
  } finally {
    isLoading.value = false;
  }
};

const cancelOrder = async (
  orderId: number,
  reasonCode: string,
  reasonDetail?: string,
): Promise<boolean> => {
  try {
    // La mise en rupture des produits est maintenant gérée automatiquement
    // par le backend lors de l'annulation (status=3)
    await changeStatus(orderId, 3, reasonCode, reasonDetail);

    // Invalider le cache du dashboard pour mettre à jour les statistiques
    const currentUser = authStore.user;
    if (currentUser?.id) {
      invalidateDashboardCache(currentUser.id);
    }

    // Recharger les données (les filtres sont déjà dans activeFilters)
    await loadOrders();

    success("Commande annulée avec succès");
    return true;
  } catch (err) {
    showError("Erreur lors de la modification du statut de la commande");
    return false;
  }
};

const changeStatus = async (
  orderId: number,
  newStatus: number,
  reasonCode?: string,
  reasonDetail?: string,
) => {
  const orderDetail = await updateOrderStatus(
    orderId,
    newStatus,
    reasonCode,
    reasonDetail,
  );
  return orderDetail as any; // Conversion simplifiée pour compatibilité
};

const handleFilter = async (filters: OrderFiltersType) => {
  currentPage.value = 1;

  // Vérifier si tous les filtres sont vides
  const hasActiveFilters = Object.values(filters).some(
    (value) => value !== null && value !== undefined && value !== "",
  );

  // Stocker les filtres actifs (gestion d'état)
  activeFilters.value = hasActiveFilters ? { ...filters } : null;

  // Sauvegarder les filtres dans le store Pinia (null si tous vides)
  ordersStore.setFilters(hasActiveFilters ? filters : null);

  await syncQueryFromPagination();
  await loadOrders();
};

// Méthodes de pagination
const handlePageChange = async (newPage: number) => {
  currentPage.value = newPage;
  await syncQueryFromPagination();
  await loadOrders();
};

const handleItemsPerPageChange = async (newItemsPerPage: number) => {
  itemsPerPage.value = newItemsPerPage;
  currentPage.value = 1; // Retour à la première page lors du changement
  await syncQueryFromPagination();
  await loadOrders();
};

function resolveOrderDetailId(orderIdOrRow: number | Order): number | null {
  const orderId =
    typeof orderIdOrRow === "number"
      ? orderIdOrRow
      : (orderIdOrRow.orderId as number) ||
        (orderIdOrRow as any).id_commande ||
        (orderIdOrRow as any).id;

  if (!orderId) {
    return null;
  }
  return orderId;
}

function getOrderDetailHref(orderIdOrRow: number | Order): string {
  const orderId = resolveOrderDetailId(orderIdOrRow);
  if (orderId === null) {
    return "#";
  }

  return router.resolve({
    name: "orderdetails-detail",
    params: { id: orderId.toString() },
    query: route.query,
  }).href;
}

const handleVoirDetail = (orderIdOrRow: number | Order) => {
  const orderId = resolveOrderDetailId(orderIdOrRow);
  if (orderId === null) {
    return;
  }

  router.push({
    name: "orderdetails-detail",
    params: { id: orderId.toString() },
    query: route.query,
  });
};

// Fonction pour obtenir la classe CSS selon le status
const getRowClass = (row: any) => {
  const result = `border-l-12 ${
    statusLegend[row.status]?.border || "!border-l-gray-300"
  }`;
  return result;
};

// Filtres initiaux pour le composant OrderFilters
const initialFilters = computed<OrderFiltersType>(() => {
  return ordersStore.filters ?? {};
});

// Initialisation
onMounted(async () => {
  if (!authStore.isInitialized) {
    await authStore.checkAuth();
  }

  if (!authStore.isAuthenticated) {
    router.push({ name: "auth" });
    return;
  }

  // Restaurer les filtres depuis le store (mis par le dashboard ou la navigation interne)
  if (ordersStore.filters) {
    activeFilters.value = { ...ordersStore.filters };
  }

  syncPaginationFromQuery();
  await syncQueryFromPagination();

  // Charger les commandes
  await loadOrders();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PageHeader), {
      title: "Mes commandes",
      subtitle: "Gérez et suivez toutes vos commandes clients",
      class: "mb-4 pr-10"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(OrderFilters), {
        "initial-filters": initialFilters.value,
        onFilters: handleFilter
      }, null, 8, ["initial-filters"]),
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-black" }, null, -1),
              _createElementVNode("p", { class: "mt-2 text-black" }, "Chargement des commandes...", -1)
            ])))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(UnifiedPagination), {
                  "current-page": currentPage.value,
                  "total-items": totalItems.value,
                  "items-per-page": itemsPerPage.value,
                  "items-per-page-options": [10, 25, 50, 100],
                  "show-first-last-buttons": true,
                  "onUpdate:currentPage": handlePageChange,
                  "onUpdate:itemsPerPage": handleItemsPerPageChange
                }, null, 8, ["current-page", "total-items", "items-per-page"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(ReusableTable), {
                  data: orders.value,
                  columns: tableHeaders.value,
                  "show-pagination": false,
                  "page-size": 999999,
                  onRowClick: handleVoirDetail
                }, {
                  "column-orderId": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, " #" + _toDisplayString(row.orderGroupId), 1)
                    ])
                  ]),
                  "column-orderDate": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(row.orderDate), 1)
                    ])
                  ]),
                  "column-groupageDate": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString(row.groupageDate || "-"), 1)
                    ])
                  ]),
                  "column-carrier": _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      title: row.carrier as string || 'Aucun transporteur',
                      class: "text-center"
                    }, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(truncateText)(row.carrier as string, 30)), 1),
                      (row.isGroupage)
                        ? (_openBlock(), _createElementBlock("br", _hoisted_15))
                        : _createCommentVNode("", true),
                      (row.isGroupage)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_16, "(groupage)"))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_13)
                  ]),
                  "column-buyer": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", {
                        title: row.buyer as string || 'Aucun acheteur',
                        class: "whitespace-normal break-words leading-tight"
                      }, _toDisplayString((row.buyer as string) || "Aucun acheteur"), 9, _hoisted_18),
                      (row.isNouveauAcheteur)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[7] || (_cache[7] = [
                            _createElementVNode("span", { class: "bg-blue-600 px-2 py-1 rounded text-white text-xs" }, "Nouveau Acheteur", -1)
                          ])))
                        : _createCommentVNode("", true),
                      (row.isPremiereCommande)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[8] || (_cache[8] = [
                            _createElementVNode("span", { class: "inline-flex items-center gap-1 bg-gradient-to-r from-gray-900 to-black px-2.5 py-1 rounded-full text-white text-xs font-semibold shadow-md ring-1 ring-white/10" }, [
                              _createElementVNode("i", { class: "fas fa-medal text-amber-400 text-[10px]" }),
                              _createTextVNode(" 1ère commande ")
                            ], -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  "column-totalExclTax": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(row.totalExclTax) + "€", 1)
                    ])
                  ]),
                  "column-shortageExclTax": _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString((row.shortageExclTax as number) > 0
                    ? (row.shortageExclTax as number) + "€"
                    : "-"), 1)
                    ])
                  ]),
                  "column-status": _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([currentStatus( row.status as string ).style])
                    }, _toDisplayString(currentStatus(row.status as string).label), 3)
                  ]),
                  "column-action": _withCtx(({ row }) => [
                    _createElementVNode("div", {
                      class: "flex gap-1",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: getOrderDetailHref(row),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        class: "w-8 h-8 bg-blue-500 hover:bg-blue-600 rounded text-white flex items-center justify-center transition-colors",
                        title: "Voir dans un nouvel onglet"
                      }, _cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "fas fa-eye text-xs" }, null, -1)
                      ]), 8, _hoisted_25),
                      (['1', '9'].includes(row.status as string))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (handleValidateOrder(row)), ["stop"]),
                            class: "w-8 h-8 bg-green-500 hover:bg-green-600 rounded text-white flex items-center justify-center transition-colors",
                            title: "Valider la commande"
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fas fa-check text-xs" }, null, -1)
                          ]), 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      (String(row.status) === '1')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (openCancelModal(row.orderId)), ["stop"]),
                            class: "w-8 h-8 bg-red-500 hover:bg-red-600 rounded text-white flex items-center justify-center transition-colors",
                            title: "Annuler"
                          }, _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "fas fa-times text-xs" }, null, -1)
                          ]), 8, _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["data", "columns"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: order.orderId,
                    onClick: ($event: any) => (handleVoirDetail(order.orderId as number)),
                    class: "bg-white rounded-lg shadow-sm border border-gray-200 p-3 cursor-pointer hover:shadow-md transition-shadow"
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_31, " #" + _toDisplayString(order.orderGroupId), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", null, "Cmd: " + _toDisplayString(order.orderDate), 1),
                          (order.groupageDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Grp: " + _toDisplayString(order.groupageDate), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass([currentStatus(order.status as string).style])
                      }, _toDisplayString(currentStatus(order.status as string).label), 3)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-black" }, "Client:", -1)),
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(truncateText)(order.buyer as string, 20)), 1),
                        (order.isNouveauAcheteur || order.isPremiereCommande)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              (order.isNouveauAcheteur)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Nouveau"))
                                : _createCommentVNode("", true),
                              (order.isPremiereCommande)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_38, _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "fas fa-medal text-amber-400 text-[8px]" }, null, -1),
                                    _createTextVNode(" 1ère ")
                                  ])))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-black" }, "Transporteur:", -1)),
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(truncateText)(order.carrier as string, 18)), 1),
                        (order.isGroupage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, " (groupage) "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-black" }, "Total HT:", -1)),
                        _createElementVNode("div", _hoisted_41, _toDisplayString(order.totalExclTax) + "€ ", 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-black" }, "Rupture HT:", -1)),
                        _createElementVNode("div", _hoisted_42, _toDisplayString((order.shortageExclTax as number) > 0
                      ? (order.shortageExclTax as number) + "€"
                      : "-"), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "flex gap-1.5 pt-2 border-t border-gray-200",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("a", {
                        href: getOrderDetailHref(order.orderId as number),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                        class: "flex-1 px-2 py-1.5 bg-blue-500 hover:bg-blue-600 rounded text-white text-xs font-medium flex items-center justify-center gap-1 transition-colors"
                      }, _cache[17] || (_cache[17] = [
                        _createElementVNode("i", { class: "fas fa-eye text-[10px]" }, null, -1),
                        _createTextVNode(" Détails ")
                      ]), 8, _hoisted_43),
                      (['1', '9'].includes(order.status as string))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _withModifiers(($event: any) => (handleValidateOrder(order)), ["stop"]),
                            class: "px-2 py-1.5 bg-green-500 hover:bg-green-600 rounded text-white flex items-center justify-center transition-colors",
                            title: "Valider"
                          }, _cache[18] || (_cache[18] = [
                            _createElementVNode("i", { class: "fas fa-check text-xs" }, null, -1)
                          ]), 8, _hoisted_44))
                        : _createCommentVNode("", true),
                      (order.status === '1')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _withModifiers(($event: any) => (openCancelModal(order.orderId as number)), ["stop"]),
                            class: "px-2 py-1.5 bg-red-500 hover:bg-red-600 rounded text-white flex items-center justify-center transition-colors",
                            title: "Annuler"
                          }, _cache[19] || (_cache[19] = [
                            _createElementVNode("i", { class: "fas fa-times text-xs" }, null, -1)
                          ]), 8, _hoisted_45))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_29))
                }), 128))
              ])
            ])),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_unref(UnifiedPagination), {
            "current-page": currentPage.value,
            "total-items": totalItems.value,
            "items-per-page": itemsPerPage.value,
            "items-per-page-options": [10, 25, 50, 100],
            "show-first-last-buttons": true,
            "onUpdate:currentPage": handlePageChange,
            "onUpdate:itemsPerPage": handleItemsPerPageChange
          }, null, 8, ["current-page", "total-items", "items-per-page"])
        ])
      ])
    ]),
    _createVNode(CancelOrderModal, {
      "is-visible": showCancelModal.value,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => ((showCancelModal).value = $event)),
      loading: isCanceling.value,
      onConfirm: confirmCancelOrder
    }, null, 8, ["is-visible", "loading"]),
    _createVNode(CommentModal, {
      show: showCommentModal.value,
      "order-id": selectedOrderId.value,
      onSubmit: submitComment,
      onCancel: closeCommentModal
    }, null, 8, ["show", "order-id"]),
    (selectedOrderForValidation.value && orderDetailForValidation.value)
      ? (_openBlock(), _createBlock(LabelGenerationModal, {
          key: 0,
          isVisible: showLabelGenerationModal.value,
          orderId: selectedOrderForValidation.value,
          orderStatus: orderDetailForValidation.value.statut || 0,
          idLivraison: 
      orderDetailForValidation.value.livraison?.id_livraison
        ? Number(orderDetailForValidation.value.livraison.id_livraison)
        : null
    ,
          carrierName: orderDetailForValidation.value.livraison?.libelle || undefined,
          orderDetailData: orderDetailForValidation.value,
          "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showLabelGenerationModal.value = $event)),
          onLabelsGenerated: handleLabelsGenerated,
          onParcelRemoved: refreshValidationOrder
        }, null, 8, ["isVisible", "orderId", "orderStatus", "idLivraison", "carrierName", "orderDetailData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})